import { useEffect } from 'react';
import { getMultiSelectionState } from '@components/MainStage/multiSelection.store';
import { useProject } from '@context/Project';

/**
 * Opening a drawer exits multi-selection: the two are mutually exclusive, since
 * no entry method works while a drawer is open. Without this the selection badge
 * could sit behind an open drawer showing a selection the user is no longer able
 * to change.
 *
 * The click-based openers (canvas entity, list row, relationship) clear the
 * selection themselves, so nothing lingers for a frame. This covers the
 * remaining paths — "Add entity" from the list / sub-layer context menu, opening
 * a relation from the Relationships submenu, and any future `setDrawer` caller.
 *
 * Only our own store is cleared (not React Flow's native selection): the drawer
 * that just opened owns the active node, and a multi-selection never leaves a
 * native selection behind anyway.
 */
const useClearSelectionOnDrawer = () => {
  const { drawer } = useProject();

  useEffect(() => {
    if (!drawer) return;

    getMultiSelectionState().clear();
  }, [drawer]);
};

export default useClearSelectionOnDrawer;
